import firebase from 'firebase';

import View from '../../../../_components/view/view.js';
import groupPlayerTpl from './group-player.tpl.html';
import './group-player.styles.less';

class GroupPlayerView extends View {

	constructor (data, options) {
		super(groupPlayerTpl, data, options);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnRemove: '.btn-remove'
		});
	}

	render(data) {
		super.render(data);
	}

	initializeEvents() {
		this.ui.btnRemove.click(() => this.removePlayer());
	}

	removePlayer() {
		this.options.__player.ref.update({
			groupId: null
		});
	}


}

export default GroupPlayerView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/groups/group/group-player/group-player.view.js